import type { Task } from '../api/tasks.ts';
import { formatInstant } from './fields.ts';
import { closedByRecordSaid } from './taskView.ts';

const NOBODY = 'a person not recorded';
const UNDATED = 'on a date not recorded';

/**
 * A-#211 fix 2: how a closed task closed, in one line, from the server's facts only (never inferred): its record
 * (A-#194, in the task card's own words), the person's completion (153's edited mark), a waive or a cancel with its
 * reason, or the system. A missing person or reason is said, never guessed. Null for a task that is not closed.
 */
export function closedLine(t: Task): string | null {
  if (t.status === 'Done' && t.closed_by_record) {
    const r = t.closed_by_record;
    return `${closedByRecordSaid(r)}${r.by ? ` · recorded by ${r.by.name}` : ''}`;
  }
  if (t.status === 'Done' && t.completion) {
    const c = t.completion;
    return `Done ${formatInstant(c.happened_at) ?? UNDATED} by ${c.by?.name ?? NOBODY}${c.edited ? ' · edited' : ''}`;
  }
  if ((t.status === 'Waived' || t.status === 'Cancelled') && t.closed) {
    const c = t.closed;
    return `${t.status} ${formatInstant(c.at) ?? UNDATED} by ${c.by?.name ?? NOBODY}: ${c.reason ?? 'no reason recorded'}`;
  }
  // A-#219: closed with nothing on record about it still says that it closed, never an empty line
  if (t.status === 'Waived' || t.status === 'Cancelled') return `${t.status}, details not recorded`;
  if (t.status === 'Done') return `Closed by the system, ${formatInstant(t.closed?.at ?? t.times.completed_at) ?? UNDATED}`;
  return null;
}
